import { render, staticRenderFns } from "./assign-team.vue?vue&type=template&id=32781128&scoped=true&"
import script from "./assign-team.vue?vue&type=script&lang=js&"
export * from "./assign-team.vue?vue&type=script&lang=js&"
import style0 from "./assign-team.vue?vue&type=style&index=0&id=32781128&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32781128",
  null
  
)

export default component.exports